{
  "fr": {
    "qrcodes": {
      "buttons": {
        "generate": "Créer un QR code"
      }
    }
  }
}
